import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tipoServicioImporterSelectors = importerSelectors(
  'tipoServicio.importer',
);

export default tipoServicioImporterSelectors;
